import { ColumnConfig, PriceListColumnKey } from '../model';

export const PriceListConfig: Record<PriceListColumnKey, ColumnConfig> = {
  name: {
    name: 'Name',
    field: 'component',
  },
  code: {
    name: 'Code',
    // field: 'NavigateLink',
    field: 'component',
  },
  createdOn: {
    name: 'Created On',
  },
  criteria: {
    name: 'Criteria',
  },
  numProducts: {
    name: 'No.Of Products',
  },
  status: {
    name: 'Status',
  },
  filterby: {
    name: 'Filter By',
    isVisible: false,
    field: 'component',
  },
  customer: {
    name: 'Customers',
    isVisible: true,
  },
  cfa: {
    name: "CFA's",
    isVisible: false,
  },
  segment: {
    name: 'Segments',
    isVisible: false,
  },
  options: {
    name: 'Actions',
    field: 'component',
    alignment: 'flex-end',
  },
};
